import { Injectable } from '@angular/core';
import {
  FieldAgentClient, PagingParameters,
  SortParameters, SortParametersDirection,
  GetOpportunitiesRequest,
  Opportunity,
} from 'ep-bt-field-agent-proxy';
import { EpbtFaCustomerService } from './epbt-fa-customer.service';
import { EpbtFaFilterService } from './epbt-fa-filter.service';
import { EpbtFaSortService } from './epbt-fa-sort.service';
import { EpbtFieldAgentService } from './epbt-field-agent.service';

@Injectable({
  providedIn: 'root'
})
export class EpbtFaOpportunityService {

  public docOpportunity: Opportunity = new Opportunity();

  customerId = -1;
  pageSize = 100;
  currency: string;
  dateFormat: string;
  bistrackSettings: any;
  webTrackUser: any;

  searchString: string;
  documentOpportunitiesRequest: GetOpportunitiesRequest;
  constructor(
    public customerService: EpbtFaCustomerService, public filterService: EpbtFaFilterService,
    private sortService: EpbtFaSortService, private client: FieldAgentClient, private fieldAgentService: EpbtFieldAgentService) {
    this.fieldAgentService.getBisTrackSetting((bistrackSettings: any) => {
      this.bistrackSettings = bistrackSettings;
      // this.gridModel = this.getGridModel([]);
    });
    this.fieldAgentService.getWebTrackUser((webTrackUser: any) => {
      this.webTrackUser = webTrackUser;
    });
  }


  // API INPUT
  getOpportunitie(customerId: any, searchString: string, subscribe: (customer: any) => void): any {
    this.documentOpportunitiesRequest = new GetOpportunitiesRequest();
    this.documentOpportunitiesRequest.webTrackUser = this.webTrackUser;
    this.documentOpportunitiesRequest.webTrackUser.customer.customerId = customerId;
    // Paging
    this.documentOpportunitiesRequest.pagingParameters = new PagingParameters();
    this.documentOpportunitiesRequest.pagingParameters.count = this.bistrackSettings.searchPageSize ? this.bistrackSettings.searchPageSize : 50;
    // Sorting
    this.documentOpportunitiesRequest.sortParameters = new SortParameters();
    this.documentOpportunitiesRequest.sortParameters.sortColumn = this.sortService.dashboardOpportunitySortValue; // "DateTimeCreated";
    this.documentOpportunitiesRequest.sortParameters.direction = this.sortService.dashboardOpportunityDirectionValue == 0 ? SortParametersDirection.Ascending : SortParametersDirection.Descending;
    // Search parameters
    this.documentOpportunitiesRequest.searchBranch = this.filterService.selectedDashboardOpportunityBranchId ? this.filterService.selectedDashboardOpportunityBranchId.toString() : '-1';
    this.documentOpportunitiesRequest.searchType = this.filterService.selectedDashboardOpportunityStatusId ? this.filterService.selectedDashboardOpportunityStatusId.toString() : '-2';
    this.documentOpportunitiesRequest.searchText = searchString == undefined ? this.filterService.dashboardOpportunitySearchValue : searchString;
    this.filterService.dashboardOpportunitySearchValue = searchString == undefined ? this.filterService.dashboardOpportunitySearchValue : searchString;

    // StatusID
    // return this.documentOpportunitiesRequest;
    this.client.getOpportunities(this.documentOpportunitiesRequest).subscribe(opportunityRes => {
      if (opportunityRes && opportunityRes.lines.length == 1) {
        subscribe(opportunityRes.lines[0]);
      } else {
        subscribe(false);
      }
    });
  }
}
